import { render, staticRenderFns } from "./PolicyStatute.vue?vue&type=template&id=21674e0a&scoped=true&"
import script from "./PolicyStatute.vue?vue&type=script&lang=js&"
export * from "./PolicyStatute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21674e0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
